import { render } from "./administrar.vue?vue&type=template&id=b2ec2f66&scoped=true"
import script from "./administrar.vue?vue&type=script&lang=js"
export * from "./administrar.vue?vue&type=script&lang=js"

import "./administrar.vue?vue&type=style&index=0&id=b2ec2f66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ec2f66"]])

export default __exports__